export function toTitleCase(str: string): string {
  // Replace underscores and hyphens with spaces
  str = str.replace(/[_-]/g, ' ');
  return str.replace(/\w\S*/g, (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());
}
